"use client";

import { useLocale, useTranslations } from "next-intl";
import { Link } from "next-view-transitions";
import { FEATURES } from "@/components/navbar/features-menu";
import { Heading } from "./heading";
import { Subheading } from "./subheading";

export const GridFeatures = () => {
  const t = useTranslations("grid");
  const fm = useTranslations("featuresMenu");
  const locale = useLocale();

  return (
    <div className="relative z-20 py-10 lg:py-32 w-full">
      <Heading as="h2">{t("heading")}</Heading>
      <Subheading className="text-center">{t("subheading")}</Subheading>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {FEATURES.map((f) => (
          <Link
            key={f.slug}
            href={`/${locale}/features/${f.slug}`}
            className="group relative rounded-2xl border border-neutral-200 dark:border-neutral-800 bg-white/40 dark:bg-neutral-900/40 backdrop-blur p-5 md:p-6 overflow-hidden transition-colors hover:border-red-500/40 flex flex-col"
          >
            <div
              className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
              style={{
                background:
                  "radial-gradient(circle at 30% 0%, rgba(239,68,68,0.12), transparent 65%)",
              }}
            />
            <div className="relative flex-1">
              <div className="flex items-center justify-between gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-red-500/10 text-red-400 ring-1 ring-red-500/30">
                  {f.icon}
                </span>
                <span className="text-[10px] uppercase tracking-wider font-semibold text-red-500/80">
                  {fm(f.tagKey)}
                </span>
              </div>
              <h3 className="mt-4 text-base md:text-lg font-bold text-neutral-900 dark:text-white tracking-tight">
                {fm(f.titleKey)}
              </h3>
              <p className="mt-1.5 text-sm text-neutral-500 dark:text-neutral-400 leading-relaxed">
                {fm(f.descKey)}
              </p>
            </div>
            <div className="relative mt-5 flex items-center gap-1.5 text-sm font-semibold text-red-500 dark:text-red-300 group-hover:text-red-400 dark:group-hover:text-red-200 transition-colors">
              <span>{t("read_more")}</span>
              <svg
                viewBox="0 0 16 16"
                className="h-4 w-4 transition-transform group-hover:translate-x-1"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden
              >
                <path d="M3 8h10M9 4l4 4-4 4" />
              </svg>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
